import { Dispatch, SetStateAction } from 'react';
import {
  Container,
  ListItem,
  ListWrapper,
} from './CatalogManagementDropdown.styled';
import { useTranslation } from 'react-i18next';
import { useNavigateWithQuery } from 'utils/hooks/useNavigateWithQuery';
import { RoutesConfig } from 'navigation/routes';
import { IRootReducerState } from 'store/store';
import { AppMode } from 'store/Common/reducers/common';
import { useSelector } from 'react-redux';

interface ICatalogManagementDropdownProps {
  setShowCatalogManagementDropdown: Dispatch<SetStateAction<boolean>>;
}

const CatalogManagementDropdown = ({
  setShowCatalogManagementDropdown,
}: ICatalogManagementDropdownProps) => {
  const { t } = useTranslation();
  const navigateWithQuery = useNavigateWithQuery();
  const appMode: AppMode = useSelector(
    (state: IRootReducerState) => state.commonInfo.appMode
  );

  return (
    <Container>
      <ListWrapper>
        <ListItem
          onClick={() => {
            navigateWithQuery(RoutesConfig.CustomModels.fullPath);
            setShowCatalogManagementDropdown(false);
          }}
        >
          {t('Model Editor')}
        </ListItem>

        {appMode === AppMode.BUYER && (
          <ListItem
            onClick={() => {
              navigateWithQuery(RoutesConfig.Suppliers.fullPath);
              setShowCatalogManagementDropdown(false);
            }}
          >
            {t('Suppliers')}
          </ListItem>
        )}

        {appMode === AppMode.SUPPLIER && (
          <>
            <ListItem
              onClick={() => {
                navigateWithQuery(RoutesConfig.Buyers.fullPath);
                setShowCatalogManagementDropdown(false);
              }}
            >
              {t('Buyers')}
            </ListItem>
            <ListItem
              onClick={() => {
                navigateWithQuery(RoutesConfig.MyModels.fullPath);
                setShowCatalogManagementDropdown(false);
              }}
            >
              {t('My Models')}
            </ListItem>
          </>
        )}
      </ListWrapper>
    </Container>
  );
};

export default CatalogManagementDropdown;
